import { render, staticRenderFns } from "./ProfileDropdown.vue?vue&type=template&id=655a6ec2&scoped=true&"
import script from "./ProfileDropdown.vue?vue&type=script&lang=js&"
export * from "./ProfileDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDropdown.vue?vue&type=style&index=0&id=655a6ec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655a6ec2",
  null
  
)

export default component.exports